import Queues from '../ui/Queues';
import Handles from '../ui/Handles';
import NodeTypeProperties from '../ui/NodeTypeProperties';
import Ownership from '../ui/Ownership';
import RetentionPolicy from '../ui/RetentionPolicy';

const Properties = ({ state, setState, onChange, onArrayChange }) => {
  const { default_queue_path } = state;

  return (
    <>
      <RetentionPolicy state={state} onChange={onChange} />
      <Ownership state={state} onChange={onChange} />
      <Queues selectedValue={default_queue_path} onChange={onChange} />
      <NodeTypeProperties state={state} onChange={onChange} />
      <Handles state={state} setState={setState} onChange={onArrayChange} />
    </>
  );
};

export default Properties;
